import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 216 216"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#F8F8F8",
      d: "M198 108c0 49.706-40.294 90-90 90s-90-40.294-90-90 40.294-90 90-90 90 40.294 90 90"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M108 116.089c19.241 0 34.839-15.914 34.839-35.545C142.839 60.914 127.241 45 108 45c-19.24 0-34.839 15.914-34.839 35.544 0 19.631 15.598 35.545 34.839 35.545",
      "clip-rule": "evenodd"
    }, null, -1),
    _createElementVNode("path", {
      fill: "currentColor",
      d: "M87.677 123.494c-6.478 0-12.73 2.498-17.373 7.009-4.65 4.518-7.304 10.693-7.304 17.181v9.873c0 2.454 1.95 4.443 4.355 4.443H76.5c-4.5 0 9 0 0 0h45c-4.5 0 4.302 0 0 0h27.145c2.405 0 4.355-1.989 4.355-4.443v-9.873c0-6.488-2.654-12.663-7.304-17.181-4.642-4.511-10.895-7.009-17.373-7.009z"
    }, null, -1)
  ])))
}
export default { render: render }